export interface verifyBankName {
    sortCode: string;
    accountNumber: string;
    
}
